import PropTypes from 'prop-types'
import styles from './Ordenamiento.module.css'

export const VistaCuadricula = ({
  requiereCuadricula = false,
  vistaCuadricula,
  setVistaCuadricula
}) => {
  return (
    <div>
      {requiereCuadricula && (
        <>
          <button
            className={`${styles.buttonVista} ${vistaCuadricula ? styles.activo : ''}`}
            onClick={() => setVistaCuadricula(true)}
            title="Vista en cuadrícula"
            type="button"
          >
            <i className="fa fa-th" />
          </button>
          <button
            className={`${styles.buttonVista} ${vistaCuadricula ? '' : styles.activo}`}
            onClick={() => setVistaCuadricula(false)}
            title="Vista en lista"
            type="button"
          >
            <i className="fa fa-bars" />
          </button>
        </>
      )}
    </div>
  )
}

VistaCuadricula.propTypes = {
  requiereCuadricula: PropTypes.bool,
  vistaCuadricula: PropTypes.bool.isRequired,
  setVistaCuadricula: PropTypes.func.isRequired
}
